






































import Vue from "vue";
export default Vue.extend({
    props: {
        totalItems: {
            required: true,
            type: Number
        },
        dotSize: {
            type: Number,
            required: false,
            default: 32
        },
        amountToShow: {
            type: Number,
            required: false,
            default: 1
        },
        translate: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data: function() {
        return {
            currentItem: 0 as number,
            startItemsToDisplay: 5 as number,
            middleItemsToDisplay: 7 as number,
            endItemsToDisplay: 5 as number
        };
    },
    computed: {
        // Return an array containing the index of the dot currently visible
        itemsMap: function(): number[] {
            let maxItems = 0 as number;
            let map = [] as number[];
            let i = 0 as number;

            if(this.currentItem <= 2) {
                // Start case
                maxItems = this.startItemsToDisplay;
            } else if (this.currentItem <= 3) {
                // Start case +1
                maxItems = this.startItemsToDisplay + 1;
            } else if (this.currentItem == this.totalItems - 2) {
                // End case + 1
                maxItems = this.endItemsToDisplay + 1;
            } else if (this.currentItem >= this.totalItems - 1) {
                // End case
                maxItems = this.endItemsToDisplay;
            } else {
                // Middle case
                maxItems = this.middleItemsToDisplay;
            }

            // Generate the current visible itemsMap base on currentItem
            for (i = 0; i < maxItems; i++) {
                let item;

                if (this.currentItem <= 4) {
                    // Start case
                    item = i;
                } else if (this.currentItem <= this.totalItems - 1) {
                    // Middle case
                    item = i + (this.currentItem - 4);
                } else {
                    // End case
                    item = (this.totalItems - this.endItemsToDisplay) + i;
                }

                map.push(item);
            }

            return map;
        },
        // Return an array of class to apply on each dot based on the current position
        itemsClassMap: function (): string[] {
            let map;

            if(this.currentItem <= 2) {
                // Start case
                map = ["large", "large", "large", "medium", "small"];
            } else if (this.currentItem <= 3) {
                // Start case +1
                map = ["medium", "large", "large", "large", "medium", "small"];
            } else if (this.currentItem == this.totalItems - 2) {
                // End case + 1
                map = ["small", "medium", "large", "large", "large", "medium"];
            } else if (this.currentItem >= this.totalItems - 1) {
                // End case
                map = ["small", "medium", "large", "large", "large"];
            } else {
                // Middle case
                map = ["small", "medium","large", "large", "large", "medium", "small"];
            }

            return map;
        },
        // Return the amount of pixel the dotted-pagination__list should translate
        translateXAmount: function(): number {
            if(this.currentItem === 0) {
                return 0;
            }

            return (this.currentItem * this.dotSize) - (2 * this.dotSize);
        }
    },

    methods: {
        previousItem: function () : void {
            if(this.currentItem !== 0) {
                this.currentItem = this.currentItem - this.amountToShow;
            }
        },
        nextItem: function () : void  {
            if(this.currentItem < this.totalItems) {
                this.currentItem = this.currentItem + this.amountToShow;
            }
        },
        goToItem: function (index: number) : void {
            if(index < this.totalItems) {
                this.currentItem = index;
            }
        },
        handleSwipeLeft: function() {
            if(this.currentItem < this.totalItems) {
                this.$emit("nextItem");
            }
        },
        handleSwipeRight: function() {
            if(this.currentItem !== 0) {
                this.$emit("previousItem");
            }
        },
        handleClick: function(index: number) {
            this.goToItem(index);
            this.$emit("goToItem", index * this.amountToShow);
        }
    }
});
